// src/pages/Contact.js
import { useDispatch } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { RxCross2 } from 'react-icons/rx';

import { CustomLoader } from '../../../services/Reducer';
import apiClient from '../../../api/apiClient';
import authServices from '../../../services/AuthServices';
import { Autocomplete, TextField } from '@mui/material';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Decimal from 'decimal.js';

const Edit = ({ edit, toggle_Edit, invoiceId, refreshData, AddcurrentPage }) => {
  const dispatch = useDispatch();

  const loader = (display) => {
    dispatch(CustomLoader(display));
  };

  const [LableData, setLableData] = useState({
    portId: null,
  });

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    entityName: '',
    mobile: '',
    password: '',
    parentId: null,
    balance: '',
    balanceCap: '',
    regDate: '',
    panNumber: null,
    nameOnAadhaar: '',
    nameOnPan: '',
    aadharNumber: '',
    aadharMask: null,
    status: '',
    approval: '',
    userType: null,
    uniqueId: '',
    gstNo: '',
    tanNumber: '',
    address: '',
    portId: null,
    otp: '',

  });

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleChange2 = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: { id: value } });

  };

  //*********************************** Fetch invoice data when the modal opens ************************************************

  const token = authServices.getToken();
  const fetchInvoiceData = async () => {
    if (edit && invoiceId) {
      loader('enable');

      try {
        const response = await apiClient.get(`/api/admin/users/${invoiceId}`, {

          headers: {
            'access_token': token,
          },

        });
        if (response.data.Status === "SUCCESS") {

          setFormData({
            id: invoiceId || '',
            name: response.data.data.name || '',
            email: response.data.data.email || '',
            mobile: response.data.data.mobile || '',
            parentId: response?.data?.data?.parentId?.id || null,
            balance: response.data.data.balance || '',
            balanceCap: response.data.data.balanceCap || '',
            regDate: response.data.data.regDate || '',
            panNumber: response.data.data.panNumber || null,
            nameOnAadhaar: response.data.data.nameOnAadhaar || '',
            nameOnPan: response.data.data.nameOnPan || '',
            aadharNumber: response.data.data.aadharNumber || '',
            aadharMask: response.data.data.aadharMask || '',
            status: response.data.data.status || '',
            approval: response.data.data.approval || '',
            userType: response.data.data.userType || null,
            uniqueId: response.data.data.uniqueId || null,
            address: response.data.data.address || '',
            portId: response?.data?.data?.portId?.id || null,

          });

          setLableData({
            portId: response?.data?.data?.portId?.name || '--',

          });
        }
        else {
          console.log(response.data.message)
        }
      } catch (error) {
        console.error('catch Error :- ', error.response ? error.response.data.message : error);
      } finally {
        loader('disable');
      }
    }
  };



  //******************************************* Handle save and update the data **************************************************

  const Alldata = {
    id: formData.id,
    parentId: {
      id: formData.parentId
      // id: 133

    },
    portId: {
      id: formData.portId
    },

    name: formData.name,
    email: formData.email,
    entityName: formData.entityName,
    mobile: formData.mobile,
    password: formData.password,
    // balance: formData.balance,
    // balanceCap: formData.balanceCap,

    balance: new Decimal(formData.balance ? formData.balance : 0.00).toFixed(2) || 0.00,
    balanceCap: new Decimal(formData.balanceCap ? formData.balanceCap : 0.00).toFixed(2) || 0.00,

    regDate: formData.regDate,
    panNumber: formData.panNumber ? formData.panNumber.toUpperCase() : '',
    nameOnAadhaar: formData.nameOnAadhaar,
    nameOnPan: formData.nameOnPan,
    aadharNumber: formData.aadharNumber,
    aadharMask: formData.aadharMask || null,
    status: formData.status,
    approval: formData.approval,
    userType: formData.userType,
    uniqueId: formData.uniqueId,
    gstNo: formData.gstNo,
    tanNumber: formData.tanNumber,
    address: formData.address,
    otp: formData.otp,
  };

  const handleSave = async () => {
    loader('enable');

    try {
      const response = await apiClient.put(`/api/admin/users/update`, Alldata, {

        headers: {
          'access_token': token,
        },

      });
      if (response.data.Status === "SUCCESS") {
        toggle_Edit();
        toast.success(response.data.message)

      }
      else {
        console.log(response.data.message)
        toast.error(response.data.message)

      }
    }
    catch (error) {
      toast.error(error.response.data.message)
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      refreshData(AddcurrentPage);
      loader('disable');
    }
  };

  // ************************************************ Get Admin Type Data ***********************************************************

  // const [adminTypeData, setAdminTypeData] = useState([]);
  // const [selectedAdmin, setSelectedAdmin] = useState(null);

  // const fetchAdminType = async () => {
  //   try {
  //     const response = await apiClient.get("/api/admin/users/getByUserType", {
  //       params: {
  //         userType: "admin",
  //         pageNumber: 0,
  //         pageSize: 200,
  //       },

  //       headers: {
  //         'access_token': token,
  //       },

  //     });

  //     const dropdownData = response.data.data.records.map((record) => ({
  //       id: record.id,
  //       name: record.name,
  //       mobile: record.mobile,
  //     }));

  //     setAdminTypeData(dropdownData);
  //   } catch (err) {
  //     if (err.response) {
  //       console.error("Error fetching Admin Data user table:", err.response.data.message);
  //     } else {
  //       console.error("Error fetching Admin Data user table:", err.message);
  //     }
  //   }
  // };


  // const handleSelectChange = (event) => {
  //   const selectedId = event.target.value;
  //   setSelectedAdmin(selectedId);
  //   console.log("Selected Admin ID:", selectedId);

  //   setFormData((prevFormData) => ({
  //     ...prevFormData,
  //     parentId: selectedId ? { id: parseInt(selectedId) } : null,
  //   }));

  // };

  // ************************************************ Get port Data ***********************************************************

  const [data, setData] = useState([]);

  const fetchPortId = async () => {
    try {
      const response = await apiClient.get(`/api/admin/port/getAll`, {
        params: {
          pageNumber: 0,
          pageSize: 200,
        },
        headers: {
          'access_token': token,
        }
      }
      );
      setData(response.data.data.records);

    } catch (err) {
      console.error('Error fetching data:', err);
    }
  };

  const filteredData = Array.from(
    new Map(data.map((item) => [item.name, item])).values()
  );

  const validData = filteredData.filter((item) => item.name);



  useEffect(() => {

    fetchInvoiceData();
    // fetchAdminType()
    fetchPortId()

  }, [invoiceId, edit]);


  return (
    <>
      {edit && (
        <div className="modal fade show d-block" id="exampleModalScrollable" tabIndex={-1} role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
          <div className="modal-dialog modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalScrollableTitle">
                  Edit Users
                </h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={toggle_Edit} >
                  < RxCross2 />
                </button>
              </div>
              <div className="modal-body-custom">
                <form>

                  <div className='row w-100'>
                    {/* <div className="spacing w-50 d-inline-block">
                      <label htmlFor="name" className="label-custom">Name</label>
                      <input
                        type="text"
                        className='input-custom'
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                      />
                    </div> */}

                    {/* <div className="spacing w-50 d-inline-block">
                      <label htmlFor="email" className="label-custom">Email</label>
                      <input
                        type="text"
                        className='input-custom'
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div> */}
                  </div>

                  <div className='row w-100'>
                    {/* <div className="spacing w-50 d-inline-block">
                      <label htmlFor="entityName" className="label-custom">entityName</label>
                      <input
                        type="text"
                        className='input-custom'
                        id="entityName"
                        name="entityName"
                        value={formData.entityName}
                        onChange={handleChange}
                      />
                    </div> */}

                    {/* <div className="spacing w-50 d-inline-block">
                      <label htmlFor="password" className="label-custom">password</label>
                      <input
                        type="text"
                        className='input-custom'
                        id="password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                      />
                    </div> */}


                  </div>

                  <div className='row w-100'>
                    {/* <div className="spacing w-50 d-inline-block">
                      <label htmlFor="mobile" className="label-custom">Mobile</label>
                      <input
                        type="text"
                        className='input-custom'
                        id="mobile"
                        name="mobile"
                        value={formData.mobile}
                        onChange={handleChange}
                      />
                    </div> */}
                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="status" className="label-custom">Status</label>
                      <select
                        className='input-custom'
                        id="status"
                        name="status"
                        value={formData.status}
                        onChange={handleChange}
                      >
                        {/* <option value="">Select Status</option> */}
                        <option value="active">Active</option>
                        <option value="Inactive">InActive</option>
                      </select>
                    </div>



                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="portId" className="label-custom">Port</label>

                      <Autocomplete
                        // className={` ${errors.portId ? 'input-error' : ''}`}
                        disablePortal
                        options={validData} // Full user object
                        getOptionLabel={(option) => option.name} // Show 'name' in dropdown
                        getOptionSelected={(option, value) => option.id === value.id} // Ensure unique selection
                        renderInput={(params) => <TextField {...params} label={LableData.portId} />}
                        onChange={(event, value) => {
                          if (value) {
                            setFormData({ ...formData, portId: value.id }); // Save 'id' in state
                          } else {
                            setFormData({ ...formData, portId: "" }); // Reset state
                          }
                        }}
                        // Key attribute setup using 'id'
                        renderOption={(props, option) => (
                          <li {...props} key={option.id}>
                            {option.name}
                          </li>
                        )}
                        // Scroll enable kare inline style ke sath
                        componentsProps={{
                          paper: {
                            style: {
                              maxHeight: '130px', // Dropdown ki maximum height
                              overflowY: 'auto',  // Scroll enable karega
                            },
                          },
                        }}
                      />

                    </div>

                    {/* <div className="spacing w-50 d-inline-block">
                      <label htmlFor="parentId" className="label-custom">ParentId</label>
                      <input
                        type="text"
                        className='input-custom'
                        id="parentId"
                        name="parentId"
                        value={formData.parentId.id}
                        onChange={handleChange2}
                      />
                    </div> */}



                    {/* <div className="spacing w-50 d-inline-block">
                      <label htmlFor="parentId" className="label-custom">Parent</label>
                      <select
                        id="parentId"
                        name="parentId"
                        // value={selectedAdmin}
                        value={formData.parentId.id}
                        onChange={handleSelectChange}
                        className={`input-custom`}
                      >
                        <option value="">Select Parent</option>
                        {adminTypeData.map((data) => (
                          <option key={data.id} value={data.id}>
                            {data.name} - {data.mobile}
                          </option>
                        ))}
                      </select>

                    </div> */}







                  </div>

                  <div className='row w-100'>
                    {/* <div className="spacing w-50 d-inline-block">
                      <label htmlFor="balance" className="label-custom">balance</label>
                      <input
                        type="number"
                        className='input-custom'
                        id="balance"
                        name="balance"
                        value={formData.balance}
                        onChange={handleChange}
                      />
                    </div> */}

                    {/* <div className="spacing w-50 d-inline-block">
                      <label htmlFor="regDate" className="label-custom">regDate</label>
                      <input
                        type="date"
                        className='input-custom'
                        id="regDate"
                        name="regDate"
                        value={formData.regDate}
                        onChange={handleChange}
                      />
                    </div> */}
                  </div>

                  <div className='row w-100'>


                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="balanceCap" className="label-custom">Balance Cap</label>
                      <input
                        type="number"
                        className='input-custom'
                        id="balanceCap"
                        name="balanceCap"
                        value={formData.balanceCap === 0.00 ? 0.00 : formData.balanceCap}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="panNumber" className="label-custom">Pan Number</label>
                      <input
                        type="text"
                        className='input-custom'
                        id="panNumber"
                        name="panNumber"
                        value={formData.panNumber ? formData.panNumber.toUpperCase() : ''}
                        onChange={handleChange}
                        maxLength="10"
                      />
                    </div>
                  </div>

                  <div className='row w-100'>
                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="nameOnAadhaar" className="label-custom">Aadhaar Name</label>
                      <input
                        type="text"
                        className='input-custom'
                        id="nameOnAadhaar"
                        name="nameOnAadhaar"
                        value={formData.nameOnAadhaar}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^[A-Za-z\s]{0,50}$/.test(value)) { // Only alphabetic characters, max 50 characters
                            handleChange(e);
                          }
                        }}
                        maxLength="50"  // Set max length to 50
                      />
                    </div>

                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="nameOnPan" className="label-custom">Pan Name</label>
                      <input
                        type="text"
                        className='input-custom'
                        id="nameOnPan"
                        name="nameOnPan"
                        value={formData.nameOnPan}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^[A-Za-z\s]{0,50}$/.test(value)) { // Only alphabetic characters, max 50 characters
                            handleChange(e);
                          }
                        }}
                        maxLength="50"  // Set max length to 50
                      />
                    </div>
                  </div>

                  <div className='row w-100'>
                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="aadharNumber" className="label-custom">Aadhaar Number</label>
                      <input
                        type="text"
                        className='input-custom'
                        id="aadharNumber"
                        name="aadharNumber"
                        value={formData.aadharNumber}
                        onChange={handleChange}
                        maxLength="12"
                      />
                    </div>

                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="approval" className="label-custom">Approval</label>
                      <select
                        className="input-custom"
                        id="approval"
                        name="approval"
                        value={formData.approval}
                        onChange={handleChange}
                      >
                        <option value="">Select Approval</option>
                        <option value="approved">Approved</option>
                        <option value="pending">Pending</option>
                      </select>
                    </div>

                    {/* <div className="spacing w-50 d-inline-block">
                      <label htmlFor="aadharMask" className="label-custom">Aadhaar Mask</label>
                      <input
                        type="text"
                        className='input-custom'
                        id="aadharMask"
                        name="aadharMask"
                        value={formData.aadharMask}
                        onChange={handleChange}
                      />
                    </div> */}
                  </div>

                  <div className='row w-100'>




                    <div className="spacing w-100 d-inline-block">
                      <label htmlFor="address" className="label-custom">Address</label>
                      <textarea
                        className="input-custom"
                        id="address"
                        name="address"
                        value={formData.address}
                        onChange={handleChange}
                        rows="3" // Number of visible lines
                      // placeholder="Enter your address here"
                      />
                    </div>


                  </div>

                  <div className='row w-100'>
                    {/* <div className="spacing w-50 d-inline-block">
                      <label htmlFor="userType" className="label-custom">User Type</label>
                      <select
                        className="input-custom"
                        id="userType"
                        name="userType"
                        value={formData.userType}
                        onChange={handleChange}
                      >
                        <option value="">Select User Type</option>
                        <option value="user">User</option>
                        <option value="admin">Admin</option>
                      </select>
                    </div> */}


                  </div>

                  {/* <div className='row w-100'>
                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="gstNo" className="label-custom">GST No</label>
                      <input
                        type="text"
                        className='input-custom'
                        id="gstNo"
                        name="gstNo"
                        value={formData.gstNo}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="tanNumber" className="label-custom">Tan Number</label>
                      <input
                        type="text"
                        className='input-custom'
                        id="tanNumber"
                        name="tanNumber"
                        value={formData.tanNumber}
                        onChange={handleChange}
                          maxLength="10"

                      />
                    </div>
                  </div> */}
                  <div className='row w-100'>

                    {/* <div className="spacing w-50 d-inline-block">
                      <label htmlFor="portId" className="label-custom">Port Id</label>
                      <input
                        type="text"
                        className='input-custom'
                        id="portId"
                        name="portId"
                        value={formData.portId.id}
                        onChange={handleChange2}
                      />
                      </div> */}


                    {/* <div className="spacing w-50 d-inline-block">
                      <label htmlFor="uniqueId" className="label-custom">Unique Id</label>
                      <input
                        type="text"
                        className='input-custom'
                        id="uniqueId"
                        name="uniqueId"
                        value={formData.uniqueId}
                        onChange={handleChange}
                      />
                    </div> */}


                  </div>

                  {/* <div className="spacing" style={{ width: '43vw' }} >
                    <label htmlFor="otp" className="label-custom">OTP</label>
                    <input
                      type="text"
                      className='input-custom'
                      id="otp"
                      name="otp"
                      value={formData.otp}
                      onChange={handleChange}
                    />
                  </div> */}

                </form>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-light" data-bs-dismiss="modal" onClick={toggle_Edit}>
                  Close
                </button>
                <button type="button" className="btn btn-primary" onClick={handleSave}>
                  Save changes
                </button>
              </div>
            </div>
          </div >
        </div >
      )}
    </>
  );
};

export default Edit;
